export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.707 6.293a1 1 0 010 1.414l-6 6-1.414-1.414L5.586 7 .293 1.707 1.707.293l6 6z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "8",
    "height": "14",
    "viewBox": "0 0 8 14",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};